var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.7946v10.757c0 .625.3507 1.2153.9375 1.434 3.0208 1.1285 6.0417.3577 9.0625-.4132 2.7708-.7048 5.5417-1.4132 8.309-.6562.7986.2187 1.691-.3299 1.691-1.1598V4.003c0-.625-.3507-1.2153-.9375-1.434-3.0208-1.1285-6.0417-.3577-9.0625.4131-2.7708.7049-5.5417 1.4098-8.309.6528C.8889 3.4162 0 3.9648 0 4.7946m10 8.316c-1.5347 0-2.7778-1.493-2.7778-3.3333S8.4652 6.4439 10 6.4439s2.7778 1.4931 2.7778 3.3334S11.5347 13.1106 10 13.1106m-7.7778 0c1.2257 0 2.2222.9965 2.2222 2.2222H2.2222zm2.2222-7.2222c0 1.2257-.9965 2.2222-2.2222 2.2222V5.8884zm13.3334 5.5555v2.2223h-2.2222c0-1.2257.9965-2.2223 2.2222-2.2223m-2.2222-7.2222h2.2222V6.444c-1.2257 0-2.2222-.9965-2.2222-2.2222Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/money.1b0fbcee7bf2db2652d6d67ad6194f7e.svg";